import { CardIcon, PenIcon, TrophyIcon, ZapIcon } from "@/components/icons";

export function LoginScreen({ onEnter }: { onEnter: () => void }) {
  return (
    <section className="screen-enter">
      <div className="lpc-hero">
        <img
          className="lpc-hero__img"
          src="/assets/hero-conquista-rua.jpg"
          alt="Rider Vammo pilotando na cidade"
          onError={(e) => ((e.target as HTMLImageElement).style.display = "none")}
        />
        <div className="lpc-hero__body">
          <span className="eyebrow">
            <ZapIcon />
            Rebeldes por natureza
          </span>
          <img
            className="lpc-hero__logo"
            src="/assets/logo-vammo.svg"
            alt="Vammo"
            onError={(e) => ((e.target as HTMLImageElement).style.display = "none")}
          />
          <div className="lpc-hero__brand">Conquista</div>
          <p className="lpc-sub" style={{ marginBottom: 0 }}>
            O futuro da mobilidade, <strong>agora no seu nome</strong>.
          </p>
        </div>
      </div>

      <div className="lpc-wrap">
        <div className="lpc-statement">
          <p className="lpc-statement__lead">Você pediu. A Vammo ouviu.</p>
          <p className="lpc-statement__sub">
            Agora sua moto pode ser sua. Uma nova opção pra quem quer ir além do aluguel.
          </p>
        </div>

        <div className="lpc-highlight">
          <div className="lpc-zz" />
          <div className="lpc-highlight__title">Como funciona</div>
          <p className="lpc-highlight__lead">Continua tudo igual: só a moto que passa a ser sua.</p>
          <p className="lpc-highlight__box">
            Você aluga por 36 meses. No fim, <span className="lp-accent">a moto é a sua conquista.</span>
          </p>
        </div>

        <div className="lpc-how" style={{ marginBottom: 8 }}>
          <p className="lpc-how__title">Sua conquista em apenas 2 passos</p>
          <div className="lpc-step2">
            <span className="lpc-step2__num">01</span>
            <span className="lpc-step2__ic">
              <PenIcon />
            </span>
            <div>
              <div className="lpc-step2__h">Assine on-line, sem sair de casa.</div>
              <div className="lpc-step2__t">Novo contrato, direto pelo celular, em poucos minutos.</div>
            </div>
          </div>
          <div className="lpc-step2">
            <span className="lpc-step2__num">02</span>
            <span className="lpc-step2__ic">
              <CardIcon />
            </span>
            <div>
              <div className="lpc-step2__h">Pague só a diferença da caução.</div>
              <div className="lpc-step2__t">À vista ou parcelado na semanal, você escolhe.</div>
            </div>
          </div>
        </div>

        <div className="lpc-recap">
          <div className="lpc-zz" />
          <span className="lpc-recap__ic">
            <TrophyIcon />
          </span>
          <p className="lpc-recap__h">Sua caução pode virar parte da compra.</p>
          <p className="lpc-recap__t">
            Ao final do plano, se você não tiver pendências com a Vammo, o valor integral da sua
            caução é usado na quitação da sua moto.
          </p>
        </div>

        <div className="lpc-card lpc-card--muted" style={{ marginTop: 8 }}>
          <p style={{ color: "#fff", fontSize: 15, lineHeight: 1.6 }}>
            Durante os 36 meses você segue com <strong>todos os benefícios Vammo</strong>: rede de
            troca de baterias, moto reserva, manutenção e atendimento — agora construindo algo que
            é seu.
          </p>
        </div>
      </div>

      <div className="lpc-loginbar">
        <div className="lpc-loginbar__wrap">
          <button className="btn btn--primary" data-testid="login-cta" onClick={onEnter}>
            Acesse sua conta para saber mais
          </button>
          <p className="lpc-micro" style={{ textAlign: "center" }}>
            Entrar não muda nada no seu plano — você só vê as suas condições. A migração acontece
            apenas se você assinar o novo contrato.
          </p>
        </div>
      </div>
    </section>
  );
}
